import { useSelector } from 'store/store'
import { TabsList } from 'components'
import GeneralInfoTab from './components/GeneralInfoTab'
import MaterialsTab from './components/MaterialsTab'
import InvoicesTable from './components/InvoicesTable'
import ShipmentTab from './components/ShipmentTab'
import * as S from './styled'

import TextAndNDTab from './components/TextAndNDTab'

interface OvDetailsTabsProps {
  hasShipment?: boolean
  isBilled?: boolean
}
const OvDetailsTabs = ({ hasShipment = false, isBilled = false }: OvDetailsTabsProps) => {
  const { ovInitialTab } = useSelector((state) => state.structure)
  return (
    <S.Wrapper>
      <TabsList initialTab={ovInitialTab}>
        <TabsList.Tab label="Informações gerais">
          <GeneralInfoTab />
        </TabsList.Tab>
        <TabsList.Tab label="Material">
          <MaterialsTab />
        </TabsList.Tab>
        <TabsList.Tab label="Textos e ND">
          <TextAndNDTab />
        </TabsList.Tab>
        <TabsList.Tab hidden={!hasShipment && !isBilled} label="Remessa">
          <ShipmentTab />
        </TabsList.Tab>
        <TabsList.Tab hidden={!isBilled} label="Faturamento">
          <InvoicesTable />
        </TabsList.Tab>
      </TabsList>
    </S.Wrapper>
  )
}

export default OvDetailsTabs
